import { render, staticRenderFns } from "./integralOredr.vue?vue&type=template&id=fcc33c08&scoped=true&"
import script from "./integralOredr.vue?vue&type=script&lang=js&"
export * from "./integralOredr.vue?vue&type=script&lang=js&"
import style0 from "./integralOredr.vue?vue&type=style&index=0&id=fcc33c08&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc33c08",
  null
  
)

export default component.exports